<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromJobLog" :rules="rules" ref="fromJobLog" class="demo-form-inline">
                <el-row :gutter="20">
                    <td-permission :oneOfPermissions="permissionsQuery">
                        <div slot="havePermission">
                            <el-col :span="24">
                                <el-form-item :label="$t('common.OPERATE_TIME')" prop="startTime">
                                    <td-date-time v-model="fromJobLog.startTime" type="datetime" :clearable="false" :pickerOptions="pickerBeginDateBefore" :placeholder="$t('common.START_TIME')"></td-date-time>
                                </el-form-item>
                                <el-form-item :label="$t('common.UNTIL')" prop="endTime">
                                    <td-date-time v-model="fromJobLog.endTime" type="datetime" :clearable="false" :pickerOptions="pickerBeginDateAfter" :placeholder="$t('common.END_TIME')"></td-date-time>
                                </el-form-item>
                                <el-form-item :label="$t('common.JOB_NAME')" prop="jobName">
                                    <td-input v-model="fromJobLog.jobName" :maxlength="inputLength"></td-input>
                                </el-form-item>
                                <el-form-item class="paddingLeft10">
                                    <td-button type="primary" :loading="loading" @click="btnClickQuery">{{ $t('common.QUERY') }}</td-button>
                                </el-form-item>
                            </el-col>
                        </div>
                    </td-permission>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :hasIndex="hasIndex"
                :hasMutiSelect="false"
                :permissions="permissionsQuery"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                ref="listQueryInfo"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
        </el-main>
    </el-container>
</template>
<script>
import resourceApi from './assets/api.js';
export default {
    data() {
        return {
            fromJobLog: {
                sOperationDescribe: '',
                startTime: new Date(Date.parse((this.getNowDate() + ' 00:00:00').replace(/-/g, '/'))),
                endTime: new Date(Date.parse((this.getNowDate() + ' 23:59:59').replace(/-/g, '/')))

            },
            loading: false,
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            hasIndex: false,
            permissionsQuery: ['operationLog:view'],
            tableData: [],
            rules: {
                jobName: [{ pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }]
            },
            inputLength: 100,
            columns: [
                {
                    prop: 'sJobname',
                    label: 'common.JOB_NAME',
                    align: 'center',
                    tableWidth: '150'
                },
                {
                    prop: 'sGroupname',
                    label: 'common.JOB_GROUP',
                    tableWidth: '100',
                    showOverflowTooltip: true,
                    render: (createElement, params) => {
                        if (params.row.sGroupname === 'defaultGroup') {
                            return createElement('span', this.$t(''));
                        }
                        return createElement('span', params.row.sGroupname);
                    }
                },
                {
                    prop: 'dtTime',
                    label: 'common.OPERATE_TIME',
                    align: 'center',
                    tableWidth: '200'
                },
                {
                    prop: 'sResultState',
                    label: 'pgCommon.RUN_STATE',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        if (params.row.sResultState === 'COMPLETE') {
                            return createElement('span', this.$t('pgCommon.JOB_COMPLETE'));
                        } else if (params.row.sResultState === 'ERROR') {
                            return createElement('span', this.$t('pgCommon.JOB_ERROR'));
                        } else if (params.row.sResultState === 'RUNNING') {
                            return createElement('span', this.$t('pgCommon.JOB_RUNNING'));
                        } else {
                            return createElement('span', this.$t('pgCommon.JOB_WAITTING'));
                        }
                    }
                },
                {
                    prop: 'iTimeConsuming',
                    label: 'common.JOB_RUNTIME',
                    align: 'center',
                    tableWidth: '100',
                    render: (createElement, params) => {
                        let minute = 0;
                        let hour = 0;
                        let time = params.row.iTimeConsuming + 'ms';
                        let second = params.row.iTimeConsuming / 1000;
                        if (second > 1) {
                            minute = second / 60;
                            time = this.formatFloat(second, 2) + 's';
                        }
                        if (minute > 1) {
                            hour = minute / 60;
                            time = this.formatFloat(minute, 2) + 'min';
                        }
                        if (hour > 1) {
                            time = this.formatFloat(hour, 2) + 'h';
                        }
                        return createElement('span', time);
                    }
                },
                {
                    prop: 'sJobClass',
                    label: 'common.JOB_BEAN_PATH',
                    // tableWidth: '300',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sResultDesc',
                    label: 'common.JOB_ERROR_LOG',
                    align: 'left',
                    showOverflowTooltip: true
                }
            ],
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.fromJobLog.endTime;
                    if (dateVal) {
                        return time.getTime() > new Date(dateVal).getTime();
                    }
                }
            },
            // 数字格式化
            formatFloat(src, pos) {
                return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.fromJobLog.startTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(dateVal).getTime() - 8.64e7;
                    }
                }
            }
        };
    },
    mounted() {
        this.btnClickQuery();
    },
    methods: {
        // 点击查询按钮查询
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
          //获取当前日期
        getNowDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },


        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                jobName: this.fromJobLog.jobName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                startTime: this.fromJobLog.startTime,
                endTime: this.fromJobLog.endTime,
                isPage: true
            };
            resourceApi.findJoRunLog(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('/timedTaskManager/findJoRunLog', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/timedTaskManager/findJoRunLog', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        }
    },
    watch: {
        ['fromJobLog.startTime'](val) {
            let dateVal = this.fromJobLog.endTime;
            if (dateVal && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.fromJobLog.endTime = val;
            }
        },
        ['fromJobLog.endTime'](val) {
            let dateVal = this.fromJobLog.startTime;
            if (dateVal && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.fromJobLog.startTime = val;
            }
        }
    }
};
</script>
